import React from 'react';
import { css } from '@emotion/core';
import { FormattedMessage } from 'react-intl';
import IconSvg from '../../common/IconSvg';

export const LetsGoButton = () => (
  <span>
    <FormattedMessage id="onboarding.buttons.letsGo" />
    <IconSvg type="onboarding-lets-go" size={21} />
  </span>
);

export const WelcomeRocket = () => (
  <div style={{ textAlign: 'center' }}>
    <IconSvg
      type="onboarding-welcome"
      size={152}
      css={css`
        margin-top: 20px;
      `}
    />
    <p style={{ fontFamily: 'Heebo-Bold', marginTop: '20px' }}>
      Follow us on social media for updates and tips
    </p>
    <div
      css={css`
        display: flex;
        justify-content: center;
        a {
          display: flex;
          align-items: center;
          margin: 0 10px;
          padding: 11px 13px;
          border-radius: 10px;
          color: #586784;
          &:hover {
            color: #363b51;
          }
          &:focus {
            text-decoration: none;
          }
        }
      `}
    >
      <a
        style={{ border: '1px solid #FF0000' }}
        href="https://www.youtube.com/channel/UCJaNmCTrnNo3X0ZboCcwwNA"
        rel="noopener noreferrer"
        target="_blank"
      >
        <IconSvg size={21} type="youtube_logo" marginRight="11px" />
        <FormattedMessage id="social.youtubeButton" />
      </a>
      <a
        style={{ border: '1px solid #1877f2' }}
        href="https://www.facebook.com/TriplemarsB2B"
        rel="noopener noreferrer"
        target="_blank"
      >
        <IconSvg size={21} type="facebook_logo" marginRight="11px" />
        <FormattedMessage id="social.facebookButton" />
      </a>
      <a
        style={{ border: '1px solid #FE6338' }}
        href="https://www.instagram.com/triplemarsb2b/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <IconSvg size={21} type="instagram_logo" marginRight="11px" />
        <FormattedMessage id="social.instagramButton" />
      </a>
    </div>
  </div>
);

export const WelcomeTitle = () => (
  <span
    css={css`
      display: block;
      padding: 32px 0 10px;
      font-size: 30px;
    `}
  >
    <FormattedMessage id="onboarding.screen1.welcomeTo" />
    &nbsp;
    <b>
      <FormattedMessage id="common.tripleMars" />
    </b>
  </span>
);

export const WelcomeSubtitle = () => (
  <span>
    <FormattedMessage id="onboarding.screen1.subtitle1" />
    <br />
    <FormattedMessage id="onboarding.screen1.subtitle2" />
  </span>
);
